import {
  FaBell,
  FaBullhorn,
  FaGavel,
  FaPeopleGroup,
  FaShieldHalved,
  FaStore,
  FaTriangleExclamation,
  FaTruckRampBox,
  FaUserGear,
} from 'react-icons/fa6'
import { AdminAuctionsModule } from './auctions/AdminAuctions'
import { AdminConsignmentsModule } from './consignments/AdminConsignments'
import { AdminContentModule } from './content/AdminContent'
import { AdminNotificationsModule } from './notifications/AdminNotifications'
import { AdminOrdersModule } from './orders/AdminOrders'
import { AdminRiskModule } from './risk/AdminRisk'
import { AdminSettingsModule } from './settings/AdminSettings'
import { AdminShopModule } from './shop/AdminShop'
import { AdminUsersModule } from './users/AdminUsers'

export const adminModuleRegistry = {
  auctions: {
    title: 'Auction Operations',
    detail: 'Create, schedule, feature, start, and close timed auction lots.',
    icon: <FaGavel />,
    render: ({ apiToken, auctionRows, bidRows, orderRows, onRefresh }) => <AdminAuctionsModule apiToken={apiToken} auctionRows={auctionRows} bidRows={bidRows} orderRows={orderRows} onRefresh={onRefresh} />,
  },
  shop: {
    title: 'Buy-Now Inventory',
    detail: 'Publish fixed-price listings, manage inventory, and control bundle eligibility.',
    icon: <FaStore />,
    render: ({ apiToken, listingRows, onRefresh }) => <AdminShopModule apiToken={apiToken} listingRows={listingRows} onRefresh={onRefresh} />,
  },
  orders: {
    title: 'Order Operations',
    detail: 'Run checkout reminders, shipping updates, penalties, and relist actions.',
    icon: <FaTruckRampBox />,
    render: ({ apiToken, orderRows, onExportCsv, onRefresh }) => <AdminOrdersModule apiToken={apiToken} orderRows={orderRows} onExportCsv={onExportCsv} onRefresh={onRefresh} />,
  },
  users: {
    title: 'User Controls',
    detail: 'Review bidder verification, account status, permissions, and payment readiness.',
    icon: <FaPeopleGroup />,
    render: ({ apiToken, userRows, onRefresh }) => <AdminUsersModule apiToken={apiToken} userRows={userRows} onRefresh={onRefresh} />,
  },
  consignments: {
    title: 'Consignment Desk',
    detail: 'Create intake records, convert listings, track sales, and close manual payouts.',
    icon: <FaUserGear />,
    render: ({ apiToken, consignmentRows, onExportCsv, onRefresh }) => <AdminConsignmentsModule apiToken={apiToken} consignmentRows={consignmentRows} onExportCsv={onExportCsv} onRefresh={onRefresh} />,
  },
  content: {
    title: 'Homepage Control',
    detail: 'Manage carousel, featured auctions, fixed-price spotlights, and drop visibility.',
    icon: <FaBullhorn />,
    render: ({ apiToken, auctionRows, listingRows, onRefresh }) => <AdminContentModule apiToken={apiToken} auctionRows={auctionRows} listingRows={listingRows} onRefresh={onRefresh} />,
  },
  notifications: {
    title: 'Notification Center',
    detail: 'Send customer alerts for drops, announcements, wins, and checkout reminders.',
    icon: <FaBell />,
    render: ({ apiToken, onRefresh }) => <AdminNotificationsModule apiToken={apiToken} onRefresh={onRefresh} />,
  },
  risk: {
    title: 'Risk & Relist',
    detail: 'Monitor unpaid wins, penalties, auction lifecycle jobs, and relist review.',
    icon: <FaTriangleExclamation />,
    render: ({ apiToken, consignmentRows, onRefresh, onSectionChange, orderRows }) => <AdminRiskModule apiToken={apiToken} consignmentRows={consignmentRows} onRefresh={onRefresh} onSectionChange={onSectionChange} orderRows={orderRows} />,
  },
  settings: {
    title: 'Admin Settings',
    detail: 'Review platform workflow rules and operational defaults.',
    icon: <FaShieldHalved />,
    render: () => <AdminSettingsModule />,
  },
}
